import { render, staticRenderFns } from "./sendGoodsPrivate.vue.js?vue&type=template&id=56458d62&scoped=true!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./sendGoodsPrivate.vue?vue&type=template&id=56458d62&scoped=true"
import script from "./sendGoodsPrivate.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./sendGoodsPrivate.vue?vue&type=script&lang=js"
export * from "./sendGoodsPrivate.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./sendGoodsPrivate.vue?vue&type=script&lang=js"
import style0 from "./sendGoodsPrivate.vue.scss?vue&type=style&index=0&id=56458d62&lang=scss&scoped=true!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./sendGoodsPrivate.vue?vue&type=style&index=0&id=56458d62&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56458d62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56458d62')) {
      api.createRecord('56458d62', component.options)
    } else {
      api.reload('56458d62', component.options)
    }
    module.hot.accept("./sendGoodsPrivate.vue.js?vue&type=template&id=56458d62&scoped=true!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./sendGoodsPrivate.vue?vue&type=template&id=56458d62&scoped=true", function () {
      api.rerender('56458d62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/live/liveRoom/components/Dialog/sendGoodsPrivate.vue"
export default component.exports